import Vue from 'vue'
import './registerServiceWorker'
import router from './router'
import mixin from '@/plugins/mixins/mixin'
import formMixin from '@/plugins/mixins/formMixin'
import store from './store'
import vuetify from '@/plugins/vuetify' // path to vuetify export
import App from './App.vue'
import VueMq from 'vue-mq'
import VueMask from 'v-mask'
import './plugins/filter';
require('./css/index.css')
import '../public/css/materialdesignicons.min.css'
import Axios from './plugins/axios'
import TefAxios from './plugins/tefAxios'
import VCurrencyField from 'v-currency-field'
import { VTextField } from 'vuetify/lib'
import useIdle from './plugins/useIdle'
import '@mdi/font/css/materialdesignicons.css'
import FingerprintPlugin from '@/plugins/fingerprint'

// Directives
import flashOnChange from "@/plugins/directives/flashOnChange"

Vue.directive("flash-on-change", flashOnChange)

// ── Troiachat widget ─────────────────────────────────────────────────────────
;(function() {
  window.troiaWidgetConfig = {
    channelId: '6a30541f0aa1407d37ff9576',
    token: '7d71a3499108d0e5ca84a047ac068858e42c3fdbbbd3cb63691e2901ea331cf7',
    apiUrl: 'https://backend.troiachat.com',
    socketUrl: 'https://backend.troiachat.com',
    brandColor: '#1B153B',
    position: 'bottom-right',
    welcomeMessage: 'Olá! Bem vindo ao suporte da Magnadata. Como posso te ajudar?',
    agentName: 'Atendimento'
  }

  const script = document.createElement('script')
  script.src = 'https://widget.troiachat.com/widget.umd.js'
  script.async = true
  document.head.appendChild(script)

  script.onload = () => {
    const configureWidget = () => {
      const widget = document.getElementById('troia-widget-container')

      if (widget) {
        widget.classList.add('oryx-troia-widget')
        return true
      }

      return false
    }

    if (!configureWidget()) {
      const observer = new MutationObserver(() => {
        if (configureWidget()) observer.disconnect()
      })

      observer.observe(document.body, { childList: true, subtree: true })
    }

    const isEditableField = element => element && element.matches && element.matches(
      'input:not([type="button"]):not([type="checkbox"]):not([type="hidden"]):not([type="radio"]):not([type="reset"]):not([type="submit"]), textarea, select, [contenteditable="true"]'
    )

    const updateFieldState = () => {
      const widget = document.getElementById('troia-widget-container')
      if (!widget) return

      const activeElement = document.activeElement
      const isEditingOutsideWidget = isEditableField(activeElement) && !widget.contains(activeElement)
      widget.classList.toggle('oryx-troia-widget--field-active', isEditingOutsideWidget)
    }

    document.addEventListener('focusin', updateFieldState)
    document.addEventListener('focusout', () => requestAnimationFrame(updateFieldState))
  }
})()
// ─────────────────────────────────────────────────────────────────────────────

Vue.component('v-text-field', VTextField)
Vue.use(VCurrencyField, {
	locale: 'pt-BR',
	decimalLength: 2,
	autoDecimalMode: true,
	min: null,
	max: null,
	defaultValue: 0,
    valueAsInteger: false,
    allowNegative: false
})
Vue.prototype.$axios = Axios()
Vue.prototype.$tefAxios = TefAxios()

Vue.config.productionTip = false

Vue.mixin(mixin)
Vue.mixin(formMixin)
Vue.use(VueMq, {
	breakpoints: {
		sm: 450,
		md: 1000,
		lg: Infinity,
	},
	defaultBreakpoint: 'sm'
})

Vue.use(VueMask, {
	placeholders: {
		U: /([0-9A-ZÀ-Ú ])+/,
	}
})

Vue.use(FingerprintPlugin)

new Vue({
	vuetify,
	router,
	store,
	render: h => h(App)
}).$mount('#app')

store.watch(
	state => state.lxl.lxl,
	(newLxl) => {
		if (newLxl?.lxllogin && newLxl?.lxlnaorenv) {
			Vue.use(useIdle)
		}
	}
)